import { ErrorHandler } from '@angular/core';

export class CustomErrorHandler implements ErrorHandler {
  handleError(error: any): void {

    const whiteList=['/questionnaire/result','/questionnaire/login']
    
    if (error.name == 'HttpErrorResponse' && error.status != 404) {
      if (!whiteList.some(str=> window.location.href.includes(str))) {
        if (
          !localStorage.getItem('error-count') ||
          Number(localStorage.getItem('error-count')) <= 2
        ) {
          if (!localStorage.getItem('error-count'))
            localStorage.setItem('error-count', '1');
          localStorage.setItem(
            'error-count',
            (Number(localStorage.getItem('error-count')) + 1).toString()
          );
          location.reload();
        } else {
          localStorage.removeItem('error-count');
        }
      }
    }
    // 定制错误处理行为
    console.error('发生错误:', error);
    // 显示错误提示
    //alert('An unexpected error occurred. Please try again later.');
    // 刷新页面
    //location.reload();
  }
}
